<nav id="mainNavigation" class="navbar navbar-expand-lg navbar-light ">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" routerLink="/navigation" >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="btn-group" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                    aria-controls="dropdown-basic"  i18n="@@Search">Search<span class="caret"></span>
            </button>
            <ul id="searchMenuList" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" routerLink="/" i18n="@@FoliarTankmix">Tankmix for foliar application</a></li>
              <li role="menuitem"><a class="dropdown-item" routerLink="/search-seed-treatment" i18n="@@Search Seeds">Seed Coatings Tankmix</a></li>
              <div class="dropdown-divider"></div>
              <li role="menuitem"><a class="dropdown-item" routerLink="/search-history" i18n="@@Search History">Search History</a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <div class="btn-group" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                    aria-controls="dropdown-basic"  i18n="@@Request">Request<span class="caret"></span>
            </button>
            <ul id="requestMenuList" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" routerLink="/request" i18n="@@FoliarTankmix">Foliar Tankmix</a></li>
              <li role="menuitem"><a class="dropdown-item" routerLink="/request-seed-treatment" i18n="@@Seed Request">Seed Coatings Tankmix</a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <div class="btn-group" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                    aria-controls="dropdown-basic"  i18n="@@Advice">Advice<span class="caret"></span>
            </button>
            <ul id="adviceMenuList" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" routerLink="/advice/On Mixing" i18n="@@Mixing">On mixing</a></li>
               
            </ul>
          </div>
        </li>

        <!-- about-->
        <li class="nav-item">
          <div class="btn-group" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                    aria-controls="dropdown-basic"  i18n="@@About">About<span class="caret"></span>
            </button>
            <ul id="requestMenuList" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" routerLink="/terms" i18n="@@Terms">Terms</a></li>
              <li role="menuitem"><a class="dropdown-item" routerLink="/contact" i18n="@@Contacts">Contacts
                  </a></li>
            </ul>
            </div>
            </li>

        <li class="nav-item">
          <app-language-chooser *ngIf="showLanguageChooser" (languageChange)="changeLanguage($event)" ></app-language-chooser>
        </li>
      </ul>
      
    </div>
  </div>
</nav>
